import styled, { FlattenSimpleInterpolation, css } from "styled-components";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import iconCancel from "../../../assets/images/icons/cancel.svg";
import iconBack from "../../../assets/images/icons/back.svg";
import iconArrowLeft from "../../../assets/images/icons/arrow-left-straight.svg";

import { BIG_TITLE_VARIANT } from ".";

/* The notch zone is painted by Layout's TopInsetSpacer; the parent
 * tray container folds env(safe-area-inset-top) into its padding so
 * this header starts below the spacer. */
export const StyledTrayHeader = styled.div`
  position: relative;
  ${breakpoints.smUp} {
    padding-top: 35px;
    margin-bottom: 40px;
  }
  ${breakpoints.smDown} {
    background-color: ${colors.white};
    padding: 20px 15px;
  }
`;

export const StyledTrayHeaderTitle = styled.h2<{ textStyle?: FlattenSimpleInterpolation; variant: string }>`
  text-align: center;
  text-transform: uppercase;
  font-size: 50px;
  line-height: 1;
  letter-spacing: 0.5px;
  font-family: ${fonts.fontInterstateUltraBlack};
  ${breakpoints.smDown} {
    font-size: 20px;
  }
  ${(props) =>
    props.variant === BIG_TITLE_VARIANT &&
    css`
      text-align: left;
      padding: 0px 40px;
      font-size: 50px;
      line-height: 45px;

      ${breakpoints.smDown} {
        text-align: left;
        padding: 0;
        font-size: 45px;
      }
    `}
  ${(props) => props.textStyle};
`;

export const StyledTrayHeaderBtnClose = styled.button<{ useCloseButton?: boolean; variant: string }>`
  position: absolute;
  width: 25px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 16px;
  background-image: url("${iconBack}");
  ${breakpoints.smUp} {
    background-image: url("${(props) => (props.useCloseButton ? iconCancel : iconArrowLeft)}");
    left: 27px;
    top: -13px;
    background-size: 20px;
    height: 25px;
  }
  ${breakpoints.smDown} {
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    ${(props) =>
      props.variant === BIG_TITLE_VARIANT &&
      css`
        position: relative;
        left: 0;
      `};
  }
`;
